<template>
    <div>
        <div id="enquiries" class="pc" v-if="devicetype==1">
            <div class="home_top">
                <img class="image" src="../../assets/images/logo.png" alt="">
                <div class="home_title">国际打击乐协会证书查询</div>
            </div>
            <div v-if="type == 1" class="enquiries_input">
                <div class="flex number_flex">
                    <div class="number">
                        <div class="vip_bh">会员编号</div>
                        <div class="vip_bh_yw">Membership number</div>
                    </div>
                    <div>
                        <input v-model="vip_number" class="input" placeholder="请输入会员编号" type="text">
                    </div>
                </div>
            </div>
            <div v-if="type == 1" class="enquiries_input1">
                <div class="flex number_flex">
                    <div class="number">
                        <div class="vip_bh">身份证号码</div>
                        <div class="vip_bh_yw">ID number</div>
                    </div>
                    <div>
                        <input v-model="id_number" class="input" placeholder="请输入身份证号码" type="text">
                    </div>
                </div>
                <div @click="enquiriesClick" class="but_bottom">
                    <div  class="but_bottom_cx">查询</div>
                    <div class="but_bottom_in">Inquire</div>
                </div>
            </div>

            <div v-if="type == 2" class="enquiries_input">
                <div class="flex number_flex">
                    <div class="number">
                        <div class="vip_bh">教师编号</div>
                        <div class="vip_bh_yw">Teacher number</div>
                    </div>
                    <div>
                        <input v-model="teacher_number" class="input" placeholder="请输入教师编号" type="text">
                    </div>
                </div>
            </div>
            <div v-if="type == 2" class="enquiries_input1">
                <div class="flex number_flex">
                    <div class="number">
                        <div class="vip_bh">身份证号码</div>
                        <div class="vip_bh_yw">ID number</div>
                    </div>
                    <div>
                        <input v-model="id_number" class="input" placeholder="请输入身份证号码" type="text">
                    </div>
                </div>
                <div @click="enquiriesClick"  class="but_bottom">
                    <div class="but_bottom_cx">查询</div>
                    <div class="but_bottom_in">Inquire</div>
                </div>
            </div>

            <div v-if="type == 3" class="enquiries_input">
                <div class="flex number_flex">
                    <div class="number1">
                        <div class="vip_bh">证件编号</div>
                        <div class="vip_bh_yw">Certification number</div>
                    </div>
                    <div>
                        <input v-model="membership_number" class="input" placeholder="请输入证件编号" type="text">
                    </div>
                </div>
            </div>
            <div v-if="type == 3" class="enquiries_input1">
                <div class="flex number_flex">
                    <div class="number1">
                        <div class="vip_bh">证件持有人身份证号码</div>
                        <div class="vip_bh_yw">Holder id number</div>
                    </div>
                    <div>
                        <input v-model="id_number" class="input" placeholder="请输入身份证号码" type="text">
                    </div>
                </div>
                <div @click="enquiriesClick" class="but_bottom">
                    <div  class="but_bottom_cx">查询</div>
                    <div class="but_bottom_in">Inquire</div>
                </div>
            </div>
            <!-- 二期 -->
            <div v-if="type == 4" class="enquiries_input">
                <div class="flex number_flex">
                    <div class="number">
                        <div class="vip_bh">证书编号</div>
                        <div class="vip_bh_yw">Certification number</div>
                    </div>
                    <div>
                        <input v-model="membership_number" class="input" placeholder="请输入证书编号" type="text">
                    </div>
                </div>
            </div>
            <div v-if="type == 4" class="enquiries_input1">
                <div class="flex number_flex">
                    <div class="number">
                        <div class="vip_bh">证书持有人姓名</div>
                        <div class="vip_bh_yw">Holder Name</div>
                    </div>
                    <div>
                        <input v-model="name" class="input" placeholder="请输入持有人姓名" type="text">
                    </div>
                </div>
                <div @click="enquiriesClick" class="but_bottom">
                    <div  class="but_bottom_cx">查询</div>
                    <div class="but_bottom_in">Inquire</div>
                </div>
            </div>
        
            <div class="enquiries_bottom"></div>
             <div class="bottombar" style="bottom:120px">IPA国际打击乐协会&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2022004148号-1</a>&nbsp;china@ipa.work</div>
        </div>
        <div id="enquiriesphone" class="phone" v-if="devicetype==0">
            <div class="membership">
                <div class="membership_sh">
                    <div v-if="type == 1" class="mem_top1">
                        会员资质查询
                    </div>
                    <div v-if="type == 2" class="mem_top2">
                        师资证书查询
                    </div>
                    <div v-if="type == 3" class="mem_top3">
                        考试证书查询
                    </div>
                    <div v-if="type == 4" class="mem_top4">
                        赛事证书查询
                    </div>
                </div>
                <div v-if="type==1">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    会员编号
                                </div>
                                <div class="center_title1">
                                    Membership number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="vip_number" class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入会员编号" value="" />
                            </div>
                        </div>
                        <div class="">
                            
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    身份证号码
                                </div>
                                <div class="center_title1">
                                    ID number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="id_number" class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入身份证号码" value="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="type==2">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    教师编号
                                </div>
                                <div class="center_title1">
                                    Teacher number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="teacher_number" class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入教师编号" value="" />
                            </div>
                        </div>
                        <div class="">
                            
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    身份证号码
                                </div>
                                <div class="center_title1">
                                    ID number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="id_number" class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入身份证号码" value="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="type==3">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证件编号
                                </div>
                                <div class="center_title1">
                                    Certification number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="membership_number"  class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入证件编号" value="" />
                            </div>
                        </div>
                        <div class="">
                            
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证件持有人身份证号码
                                </div>
                                <div class="center_title1">
                                    Holder id number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="id_number" class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入身份证号码" value="" />
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 二期 -->
                <div v-if="type==4">
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证书编号
                                </div>
                                <div class="center_title1">
                                    Certification number
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="membership_number"  class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入证书编号" value="" />
                            </div>
                        </div>
                        <div class="">
                            
                        </div>
                    </div>
                    <div class="center_box">
                        <div class="flex center_box_cx">
                            <div class="center_title_flex">
                                <div class="center_title">
                                    证书持有人姓名
                                </div>
                                <div class="center_title1">
                                    Holder Name
                                </div>
                            </div>
                            <div class="center_flex_title2">
                                <input v-model="name" class="input" type="text" placeholder-style="color:#CDCDCD;" placeholder="请输入姓名" value="" />
                            </div>
                        </div>
                    </div>
                </div>

                <div @click="enquiriesClick()"  class="cx_but">
                    <div class="cx_title">
                        查询
                    </div>
                    <div class="cx_title_yw">
                        Inquire
                    </div>
                </div>
            </div>
            <div class="bottombar">IPA国际打击乐协会&nbsp;<a href="https://beian.miit.gov.cn" target="_blank">浙ICP备2022004148号-1</a>&nbsp;china@ipa.work</div>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            type:null,
            id_number:'',
            vip_number:'',
            teacher_number:'',
            membership_number:'',
            devicetype:'',
            name:''
        }
    },

    created(){
        this.type = this.$route.query.type
        this.loadDeviceType();
    },
    methods:{
         // 看是手机端还是pc端
        loadDeviceType() {
            if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|wOSBrowser|BrowserNG|WebOS)/i))) {
               this.devicetype = 0
            }
            else {
                this.devicetype = 1
            }
        },
        enquiriesClick(){
            if(this.type == 1){
                this.axios.post('/applet.php/Home/memberQualifications',{
                    number:this.vip_number,
                    id_number:this.id_number
                }).then(
                    res=>{
                        if(res.data.code==1){
                        this.$router.push({path:'/queryresultspc',query: {type:1,data:res.data.data.detail}})
                        }else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                        }
                    }
                )
            }else if(this.type == 2){
                    this.axios.post('/applet.php/Home/teachersCertificate',{
                    number:this.teacher_number,
                    id_number:this.id_number
                }).then(
                    res=>{
                        if(res.data.code==1){
                        this.$router.push({path:'/queryresultspc',query: {type:2,data:res.data.data.detail}})
                        }else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                        }
                    }
                )
            }else if(this.type == 3){
                 this.axios.post('/applet.php/Home/testCertificate',{
                    number:this.membership_number,
                    id_number:this.id_number
                }).then(
                    res=>{
                        if(res.data.code==1){
                        this.$router.push({path:'/queryresultspc',query: {type:3,data:res.data.data.detail}})
                        }else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                        }
                    }
                )
            }else if(this.type == 4){
                console.log('gameCertificate');
                 this.axios.post('/applet.php/Home/gameCertificate',{
                    number:this.membership_number,
                    name:this.name
                }).then(
                    res=>{
                        if(res.data.code==1){
                        this.$router.push({path:'/queryresultspc',query: {type:4,data:res.data.data.detail}})
                        }else{
                        this.$message({
                            message: res.data.message,
                            type: 'warning'
                        });
                        }
                    }
                )
            }
        }
    }
}
</script>

<style scoped>
/* 电脑端样式 */
#enquiries{
    min-height: 100vh;
    background: #fff;
}
.pc .home_top{
    width: 100%;
    height: 120px;
    background: #4D4D4D;
    /* background: #fff; */
    display: flex;
    align-items: center;
}
.pc .image{
    /* 922*255 */
    /* width: 238px; */
    margin-left: 360px;
    height: 74px;
    width: 267px;
}

.pc .home_title{
    font-size: 26px;
    font-weight: 600;
    color: #FFFFFF;
    margin-left: 500px;
}

.pc .enquiries_input{
    margin: 0 auto;
    top: 330px;
    position: absolute;
    left: 50%;
    transform: translate(-50%,0);
}

.pc .enquiries_input1{
    margin: 0 auto;
    position: absolute;
    left: 50%;
    top: 460px;
    transform: translate(-50%,0);
}

.pc .number{
    width: 170px;
}

.pc .number1{
    width: 240px;
    margin-right: 14px;
}

.pc .enquiries_bottom{
    width: 100%;
    height: 120px;
    background: #4D4D4D;
    position: fixed;
    bottom: 0;
    left: 0;
}
.pc .vip_bh{
    font-size: 24px;
    font-weight: 400;
    color: #4D4D4D;
}
.pc .vip_bh_yw{
    font-size: 18px;
    font-weight: 300;
    margin-top: 10px;
    color: #989898;
}
.pc .input{
    width: 507px;
    height: 74px;
    border-radius: 4px;
    border: 1px solid #979797;
    text-indent: 20px;
    margin-left: 10px;
    font-size: 24px;
}
.pc .number_flex{
    height: 74px;
    align-items: center;
}
.pc .but_bottom{
    width: 500px;
    height: 90px;
    background: #9189F8;
    border-radius: 14px;
    text-align: center;
    margin-top: 100px;
    margin-left: 95px;
}
.pc .but_bottom_cx{
    font-size: 28px;
    font-weight: 400;
    color: #FFFFFF;
    padding-top: 14px;
}
.pc .but_bottom_in{
    font-size: 20px;
    font-weight: 300;
    color: #FFFFFF;
    padding-top: 15px;
}
/* 手机端样式 */
.phone .membership{
	min-height: 100vh;
    background: #fff;
}
.phone .mem_top1{
    width: 100%;
    height: 100px;
    background: #0BC8E8;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:90px;
    text-align:center;
}
.phone .mem_top2{
    width: 100%;
    height: 100px;
    background: #FAA51F;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:90px;
    text-align:center;
}
.phone .mem_top3{
    width: 100%;
    height: 100px;
    background: #FF5467;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:100px;
    text-align:center;
}
.phone .mem_top4{
    width: 100%;
    height: 100px;
    background: #B375FF;
    font-size: 38px;
    font-weight: 600;
    color: #FFFFFF;
    line-height:100px;
    text-align:center;
}
.phone .center_title{
    font-size: 28px;
    font-weight: 400;
    color: #4D4D4D;
    margin-left: 30px;
    line-height: 40px;
}
.phone .center_title1{
    font-size: 20px;
    font-weight: 300;
    color: #989898;
    margin-left: 29px;
    line-height: 28px;
}
.phone .center_box_cx{
    display: flex;
    align-items: center;
    /* padding-top:40px;
    padding-bottom: 20px; */
}
.phone .center_box_cx:first-child{
     padding-top:20px;
}
.phone .center_box{
    /* height: 128px; */
    border-bottom: 1px solid #CCCCCC;
}
.phone .center_flex_title2{
    margin-left: auto;
    text-align: right;
    margin-right: 30px;
    font-size: 28px;
    line-height: 100px;
    /* margin-top: 54px; */
}
.phone .membership .input{
    font-size: 28px;
    line-height: 100px;
}
.phone .cx_but{
    width: 500px;
    height: 90px;
    background: #9189F8;
    border-radius: 14px;
    margin: 0 auto;
    text-align: center;
    margin-top: 100px;
}
.phone .cx_title{
    font-size: 28px;
    font-weight: 400;
    color: #FFFFFF;
    padding-top: 11px;
    line-height: 40px;
}
.phone .cx_title_yw{
    font-size: 20px;
    font-weight: 300;
    color: #FFFFFF;
    line-height: 28px;
}
</style>


// WEBPACK FOOTER //
// src/pages/enquiries/enquiries.vue